import Image from 'next/future/image';
import cn from 'classnames';
import { useState } from 'react';
import Link from 'next/link';
import { priceFormater } from '@/settings/index';
import { ConditionOptionProps } from './types';
import Tooltip from './Tooltip';
import premiumWhite from '@/public/icons/product/premium_white.svg';
import premiumBlack from '@/public/icons/product/premium_black.svg';
import HotDealBadge from '@/components/collections/hotDeals/HotDealBadge';
import { priceFormatSuperscript } from '@/lib/price';

const ConditionOption = ({
  id,
  queryParams,
  isSelected,
  option,
  matchingOffer,
  suggested,
  handleVariantSelection,
  className,
}: ConditionOptionProps) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const isPremium = option === 'Premium';

  const isDeal = !!matchingOffer.isDeal;

  return (
    <div className={cn('relative', className)}>
      <Link
        key={option}
        href={{
          pathname: '/collections/[handle]',
          query: queryParams.toString(),
        }}
        scroll={false}
        shallow
      >
        <a
          data-suggested={suggested}
          id={id}
          onClick={() => {
            setIsTooltipOpen(false);
            handleVariantSelection();
          }}
          onMouseEnter={() => {
            if (suggested) setIsTooltipOpen(true);
          }}
          onMouseLeave={() => {
            if (suggested) setIsTooltipOpen(false);
          }}
          className={cn(
            'flex h-[50px] items-center justify-between rounded border px-2 text-left',
            {
              'border-slate-gray-200 hover:border-gray-700 hover:text-gray-700':
                !isSelected,
              'border-gray-700': isSelected,
              'border-dashed text-gray-700/50': suggested,
              'bg-gray-700 text-white': isPremium && isSelected,
            },
          )}
          // eslint-disable-next-line react/forbid-dom-props
          style={{
            background:
              isPremium && isSelected
                ? 'linear-gradient(285.62deg, #13505B 7.46%, #232222 91.74%)'
                : '',
          }}
        >
          <div>
            <span
              className={cn({
                'font-bold': isSelected,
              })}
            >
              {option}
            </span>
            <div className="mt-1">
              {priceFormatSuperscript(priceFormater.short(matchingOffer.price))}
            </div>
          </div>
          {isPremium && (
            <div className="h-full py-2">
              {isSelected && (
                <Image
                  src={premiumWhite}
                  alt="Premium Condition Selected"
                  width={14}
                  height={14}
                />
              )}
              {!isSelected && (
                <Image
                  src={premiumBlack}
                  alt="Premium Condition Unselected"
                  width={14}
                  height={14}
                />
              )}
            </div>
          )}
          {isDeal && <HotDealBadge alwaysCenter isPremiumCondition />}
        </a>
      </Link>
      {isTooltipOpen && <Tooltip />}
    </div>
  );
};

export default ConditionOption;
